/* eslint-disable max-len */

export const waPinfinance = 'https://api.whatsapp.com/send/?phone=6281322276289&text=Halo Pinhome, Saya ingin bertanya mengenai Pinhome Financial.&type=phone_number&app_absent=0';
export const waPinfinance2 = 'https://api.whatsapp.com/send/?phone=6281310803908&text=Halo Pinhome, Saya ingin bertanya mengenai Pinhome Financial.&type=phone_number&app_absent=0';
export const typeFormBL = 'https://pinhome.typeform.com/BridgingLoan';

export const whatsappPinfinancePaymentConfirm = (amount?: string) => {
  return `https://api.whatsapp.com/send/?phone=6281310803908&text=Halo Tim Pinhome,%0a%0aSaya sudah melakukan pembayaran tagihaan komisi instan sebesar ${amount ?? '[Jumlah]'}%0a%0aTerima kasih [Masukan gambar bukti bayar]`;
};